import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";
import { IdadeDoTalhao, TipoMapaTalhoes } from "../typings";

export function useIdadeDoTalhao(
  unidadeId: string,
  safraId: string,
  tipoMapa: TipoMapaTalhoes
) {
  return useQuery(
    URL.MAPAS.IDADE_DO_TALHAO(unidadeId!, safraId!),
    async () => {
      if (unidadeId && safraId) {
        const { data } = await http.get<IdadeDoTalhao>(
          URL.MAPAS.IDADE_DO_TALHAO(unidadeId!, safraId!)
        );

        return data;
      }
    },
    {
      enabled: tipoMapa === TipoMapaTalhoes.IdadeDoTalhao,
    }
  );
}
